import { InformationCircleIcon } from '@heroicons/react/outline'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from 'components/atoms/Button/Button'
import TextInput from 'components/atoms/TextInput/TextInput'
import { ResetPasswordModel } from 'entities/types/ResetPassword'
import { ResetPasswordRequest } from 'generated/iTypes'
import { useActions } from 'presenter'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { ResetPasswordFormValidator } from 'validators/usersFormValidator'
import { ReactComponent as SpinnerSVG } from '../../../assets/icons/spinner.svg'

export const ResetPassword = () => {
  const { resetPasswordAction } = useActions()
  const { formState: { errors }, handleSubmit, register, getValues } = useForm({
    defaultValues: {} as ResetPasswordModel,
    resolver: yupResolver(ResetPasswordFormValidator),
  })
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <div className='h-screen bg-bgLightBlue'>
      <div className='flex flex-col items-center justify-center text-primary-300 px-8 py-8 mx-auto md:h-screen lg:py-0 '>
        <div className='w-full bg-white rounded-2xl shadow-xl md:mt-0 sm:max-w-md xl:p-0'>
          <div className='mx-6 my-20 space-y-4 md:space-y-6 sm:p-8'>
            <h1>Reset Password</h1>
            <form
              className='space-y-4 md:space-y-6'
              onSubmit={handleSubmit(async (data) => {
                setLoading(true)
                const qs = new URLSearchParams(document.location.search)
                const passwordRequest: ResetPasswordRequest = {
                  password: getValues('password'),
                  token: qs.get('token') ?? '',
                }
                await resetPasswordAction(passwordRequest)
                setLoading(false)
              })}
            >
              <div>
                <span className='block mb-2 text-primary-300 text-sm font-bold'>Password</span>
                <TextInput type='password' {...register('password')} />
                <span className='flex flex-grow justify-start mt-2 text-error font-medium text-xs'>
                  {errors.password
                    && (
                      <>
                        <InformationCircleIcon className='h-4 w-4 mr-1' />
                        {errors.password.message}
                      </>
                    )}
                </span>
              </div>
              <div>
                <span className='block mb-2 text-primary-300 text-sm font-bold'>Confirm password</span>
                <TextInput type='password' {...register('passwordConfirmation')} />
                <span className='flex flex-grow justify-start mt-2 text-error font-medium text-xs'>
                  {errors.passwordConfirmation
                    && (
                      <>
                        <InformationCircleIcon className='h-4 w-4 mr-1' />
                        {errors.passwordConfirmation.message}
                      </>
                    )}
                </span>
              </div>
              <div className='flex items-center justify-items-end pt-2'>
                <div className='flex justify-end w-full'>
                  <Button className='h-12 items-center w-2/3' type='submit' disabled={loading}>
                    {!loading
                      ? 'Reset password'
                      : <SpinnerSVG className='inline w-6 h-6 text-gray-200 animate-spin fill-primary-200' />}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
